var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cookie-law',{attrs:{"buttonText":"Понятно"}},[_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v(" На сайте используются cookie, без них в Интернете ничего не работает! "),_c('Soglashenie')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }